import EventTreeEdge from "hcl-web-editor/app/mxGraph/HCLTreeNode/EventTreeNode/EventTreeEdge";

import { mxConstants } from "mxgraph-js";

class DecisionPointEdge extends EventTreeEdge {

  public inactive: boolean = false;

  constructor(value: string) {
    super(DecisionPointEdge.getMyStyle());
    this.value = value;
  }

  public static getMyStyle():  {[index: string]: any} {
    const edgeStyle:  {[index: string]: any} = {};
    edgeStyle[mxConstants.STYLE_PERIMETER_SPACING] = 0;
    edgeStyle[mxConstants.STYLE_STROKEWIDTH] = 8;
    return edgeStyle;
  }
}

export default DecisionPointEdge;
